import script from "./AuthConfigIdentity.vue?vue&type=script&setup=true&lang=ts"
export * from "./AuthConfigIdentity.vue?vue&type=script&setup=true&lang=ts"

import "./AuthConfigIdentity.vue?vue&type=style&index=0&id=30caeb16&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30caeb16"]])

export default __exports__